import { render, staticRenderFns } from "./RedemptionSummary.vue?vue&type=template&id=01077f30&scoped=true"
import script from "./RedemptionSummary.vue?vue&type=script&lang=js"
export * from "./RedemptionSummary.vue?vue&type=script&lang=js"
import style0 from "./RedemptionSummary.vue?vue&type=style&index=0&id=01077f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01077f30",
  null
  
)

export default component.exports